import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const downloadPageStyles = (theme: Theme) => ({
	root: {
		position: 'relative',
		minHeight: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	background: {
		flexGrow: 1,
		backgroundColor: Colors['FF6000'],
		position: 'relative',
		display: 'flex',
		flexFlow: 'column nowrap',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 0,
	},
	content: {
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		position: 'relative',
		paddingTop: { xs: '10vh', md: '0' },
		px: { xs: '20px', md: '50px' },
		maxWidth: '100%',
		gap: '20px',
	},
	text: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '34px', md: '48px' },
		fontWeight: 900,
		lineHeight: '1',
		color: 'black',
		marginBottom: '20px',
	},
	phonesImageWrapper: {
		maxWidth: '600px',
		overflow: 'hidden',
	},
});
